import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { enumIdentifierQualifier } from '@app/data-layer/enums/common';

@Component({
  selector: 'cbp-number-request-identifier-type-form',
  templateUrl: './cbp-number-request-identifier-type-form.component.html',
  styleUrls: ['./cbp-number-request-identifier-type-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CbpNumberRequestIdentifierTypeFormComponent implements OnInit {
  @Input() public formGroup: UntypedFormGroup;

  public enumIdentifierQualifier: typeof enumIdentifierQualifier = enumIdentifierQualifier;

  constructor() {}

  ngOnInit() {}
}
